import React from 'react';
import { useTranslation } from 'react-i18next';
import CoverInfo from './CoverInfo';
import { getDocumentName } from 'pages/Asset/tabs/Reports/components/ReportsSummary/components/PdfModal';
import dayjs from 'dayjs';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShip } from '@fortawesome/free-solid-svg-icons';

interface CoverReportDetailsProps {
  asset: { name: string; id: string };
  date: string;
  category?: string;
  assetDescription?: string;
}

const CoverReportDetails: React.FC<CoverReportDetailsProps> = ({
  asset,
  category,
  date,
  assetDescription,
}) => {
  const { t } = useTranslation();
  const documentName = getDocumentName(dayjs(date), asset?.name.split(' - ')[0]);
  return (
    <div className="cover-report-details">
      <h1 className="cover-report-details-title">{t(`pdf:coverTitle`)}</h1>
      <h1 className="cover-subtitle">
        {asset.name} - {assetDescription}
      </h1>
      <div className="cover-info-wrapper">
        <div className="cover-info box">
          <CoverInfo
            value={category}
            sectionName="category"
            icon={<FontAwesomeIcon icon={faShip} />}
          />
          <CoverInfo value={date} sectionName="date" icon={<CalendarMonthOutlinedIcon />} />
        </div>
        <CoverInfo value={documentName} sectionName={'documentNumber'} />
        <CoverInfo value={'IFU'} sectionName={'issueReason'} />
        <CoverInfo value={'0'} sectionName={'revision'} />
      </div>
    </div>
  );
};

export default CoverReportDetails;
